import React, {useState} from "react";

import {Tooltip} from "@mui/material";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";

import {ColumnFilter} from "./filters/ColumnFilter";
import {isEmpty} from "weed-js";
import {UNSORTED} from "./constants";


export const ColumnHeader = ({
    collapsed = false,
    columnDef,
    isVisible,
    onFilterChange,
    onFilterClick,
    onSortClick,
    setCollapsed = null,
    sortStack,
}) => {
    const stackPosition = !isEmpty(sortStack) && sortStack.findIndex(item => item.columnDef.getIndex() === columnDef.getIndex()) + 1 || false;
    const sortState = sortStack.find(item => item.columnDef.getIndex() === columnDef.getIndex()) || {direction: UNSORTED};
    const suffix = stackPosition ? " (" + stackPosition + ")" : "";
    const name = isEmpty(suffix) ? columnDef.displayName  : <Tooltip title={"When you see a number appear next to the column title; that indicates the sort order. (1) first, followed by (2), etc."}>{columnDef.displayName + suffix}</Tooltip>;
    const [hideModal, setHideModal] = useState(true);
    const columnFilter = <ColumnFilter
        key={"canold-table-column-filter-" + columnDef.getIndex() + "-" + columnDef.displayName}
        columnDef={columnDef}
        onChange={onFilterChange}
        hideModal={hideModal}
        setHideModal={setHideModal}
        hidden={!isVisible}
    />;

    if (!isVisible) return null;

    const thParams = {
        key: columnDef.key(),
        "data-column-index": columnDef.getIndex(),
        className: "canold-table-th",
        role: "canold-table-column-header",
        title: columnDef.displayName,
    };

    if (columnDef.style) {
        thParams.style = columnDef.style;
    }

    if (collapsed) {
        return <th {...thParams}>
            <span
                className={"canold-table-sort-icon" + (isVisible ? "" : " hidden")}
                role={"canold-table-sort-button"}
                onClick={(evt) => {
                    onSortClick(columnDef, evt);
                }}>
                <Tooltip title={"Click to expand " + columnDef.displayName}>
                    {!collapsed ?
                        <UnfoldLessIcon className={"canold-table-collapse-icon clickable rotated"} onClick={(evt) => {
                            evt.stopPropagation(); // Prevent event bubbling
                            setCollapsed && setCollapsed(!collapsed);
                            columnDef.hide();
                        }}/> :
                        <UnfoldMoreIcon className={"canold-table-collapse-icon clickable rotated"} onClick={(evt) => {
                            evt.stopPropagation(); // Prevent event bubbling
                            setCollapsed && setCollapsed(!collapsed);
                            columnDef.show();
                        }}/>}
                </Tooltip>
            </span>
        </th>
    }

    return <th {...thParams}>
        <span
            className={"canold-table-sort-icon" + (isVisible ? "" : " hidden")}
            role={"canold-table-sort-button"}
            onClick={(evt) => {
                onSortClick(columnDef, evt);
            }}>
            <Tooltip title={`Sort ${columnDef.displayName}. Click to cycle through ascending, descending, and unsorted.`}>{columnDef.getSortIcon(sortState)}</Tooltip>
            <Tooltip title={`Filter ${columnDef.displayName}. Click for options`}>
                {columnDef.getFilterIcon(onFilterClick, hideModal, setHideModal)}
            </Tooltip>
            <Tooltip title={`Show/Hide ${columnDef.displayName}`}>
                {!collapsed ? <UnfoldLessIcon className={"canold-table-collapse-icon clickable rotated"} onClick={(evt) => {
                    evt.stopPropagation(); // Prevent event bubbling
                    setCollapsed && setCollapsed(!collapsed);
                    columnDef.hide();
                }} /> : <UnfoldMoreIcon className={"canold-table-collapse-icon clickable rotated"} onClick={(evt) => {
                    evt.stopPropagation(); // Prevent event bubbling
                    setCollapsed && setCollapsed(!collapsed);
                    columnDef.show();
                }} />}
            </Tooltip>
        </span>
        {isVisible ? name : ""}
        {columnFilter}
    </th>
}